module.exports = __webpack_public_path__ + "images/旅悦好物全景_04-1.jpg?v=1f1f9b92";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue3/旅悦好物全景_04-1.jpg
 ** module id = 132
 ** module chunks = 1 2
 **/